import React, { useState } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { PageContent } from "../../components";
import { getUserPermissions } from "../../redux/auth";
import { PERMISSION_LEVEL_KEYS } from "../../constants/permissions";
import OrganizationNav from "./OrganizationNav";
import { tabs } from "./helper";

export const OrganizationSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = Number(searchParams.get("value")) || 1;
  const [value, setValue] = useState(initialTab);
  const permissions = useSelector(getUserPermissions);

  const isAllowed = (tab) => {
    if (!tab?.permission) return true;
    const userPerm = permissions?.find((p) => p.id === tab.permission);
    return (userPerm?.value ?? 0) >= PERMISSION_LEVEL_KEYS.VIEW_ONLY;
  };

  const tab = tabs.find((t) => t.id === value);
  const ActiveTab = tab && isAllowed(tab) ? tab.TabElement : <></>;

  const onSetValue = (val) => {
    const newParams = new URLSearchParams();
    newParams.set("value", val);

    setSearchParams(newParams);
    setValue(val);
  };

  return (
    <PageContent disablePadding>
      <Stack direction="row" height="100%" overflow="hidden">
        <OrganizationNav {...{ value, setValue: onSetValue }} />
        {ActiveTab}
      </Stack>
    </PageContent>
  );
};

export default OrganizationSettings;
